<template>
  <div />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: undefined,
      headDescription: undefined,
    }
  },

  /**
   */
  created() {
    this.headTitle = this.$t('headTitle')
    this.headDescription = this.$t('headDescription')
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "headTitle": "",
    "headDescription": ""
  },
  "nl-BE": {
    "headTitle": "",
    "headDescription": ""
  },
  "es-ES": {
    "headTitle": "",
    "headDescription": ""
  },
  "de-DE": {
    "headTitle": "Impressum",
    "headDescription": "Impressum"
  },
  "fr-BE": {
    "headTitle": "",
    "headDescription": ""
  },
  "fr-FR": {
    "headTitle": "",
    "headDescription": ""
  },
  "it-IT": {
    "headTitle": "",
    "headDescription": ""
  }
}
</i18n>
